import React, { useRef, useState } from "react";
import { Close } from "@mui/icons-material";
import { CaseServices } from "../../../services/CaseServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { AuthServices } from "../../../services/AuthServices";

const EditImageFeature = ({ selectedImg, setOpen, documentDetails }) => {
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [details, setDetails] = useState(null);

  const rotateLeft = () => setRotation((prev) => prev - 90);
  const rotateRight = () => setRotation((prev) => prev + 90);
  const resetImage = () => {
    setRotation(0);
    setZoom(1);
  };

  const zoomIn = () => setZoom((prev) => Math.min(prev + 0.2, 3));
  const zoomOut = () => setZoom((prev) => Math.max(prev - 0.2, 0.5));

  const handleSave = async () => {
    try {
      // Create a canvas
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // Handle rotation (swap width/height if rotated 90/270)
      const angle = ((rotation % 360) + 360) % 360;
      const isVertical = angle === 90 || angle === 270;
      canvas.width = isVertical ? details.naturalHeight : details.naturalWidth;
      canvas.height = isVertical ? details.naturalWidth : details.naturalHeight;

      // Move origin to center and rotate
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate((angle * Math.PI) / 180);

      // Draw image with zoom applied
      ctx.drawImage(
        details,
        (-details.naturalWidth / 2) * zoom,
        (-details.naturalHeight / 2) * zoom,
        details.naturalWidth * zoom,
        details.naturalHeight * zoom
      );

      // Convert canvas to Blob
      canvas.toBlob(async (blob) => {
        if (!blob) return;

        const formData = new FormData();
        formData.append("image", blob, "edited-image.png");

        let res = await AuthServices.uploadImage(formData);

        await CaseServices.saveDocumentUrl(documentDetails.id, [
          {
            ...documentDetails?.documenturlmasters[selectedImg.idx - 1],
            documentUrl: res?.data?.url,
            urlId: documentDetails?.documenturlmasters[selectedImg.idx - 1].id,
          },
        ]);
      }, "image/png");
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };

  return (
    <div className="fixed h-screen w-screen top-0 left-0 flex flex-col items-center gap-6 p-6 z-[1203] bg-[#017C5780]">
      {/* Image Box */}
      <div className="relative w-[90%] h-[90%] overflow-hidden flex items-center justify-center border rounded-xl shadow-lg bg-gray-100">
        <div className="absolute top-3 right-3" onClick={() => setOpen(false)}>
          <Close />
        </div>
        <img
          src={selectedImg.documentUrl}
          onLoad={(e) => setDetails(e.currentTarget)}
          //   crossOrigin="anonymous"
          alt="editable"
          style={{
            transform: `rotate(${rotation}deg) scale(${zoom})`,
            transition: "transform 0.3s ease",
            maxWidth: "100%",
            maxHeight: "100%",
          }}
        />
      </div>

      {/* Controls */}
      <div className="flex flex-wrap gap-3 justify-center">
        <button
          onClick={rotateLeft}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          ⬅ Rotate Left
        </button>
        <button
          onClick={resetImage}
          className="px-3 py-2 bg-blue-200 rounded hover:bg-blue-300"
        >
          🔄 Reset
        </button>
        <button
          onClick={rotateRight}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          Rotate Right ➡
        </button>
        <button
          onClick={zoomIn}
          className="px-3 py-2 bg-green-200 rounded hover:bg-green-300"
        >
          🔍 Zoom In
        </button>
        <button
          onClick={zoomOut}
          className="px-3 py-2 bg-red-200 rounded hover:bg-red-300"
        >
          🔎 Zoom Out
        </button>
        <button
          type="button"
          onClick={handleSave}
          className="px-3 py-2 bg-purple-200 rounded hover:bg-purple-300"
        >
          💾 Save
        </button>
      </div>
    </div>
  );
};

export default EditImageFeature;
